/**
 * -----------------------------------------------------------------------------
 * Popup - Report Filter
 * -----------------------------------------------------------------------------
 * This popup is used for filtering the reports.
 */

import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import ReportOptions, { TReportOptionsProps } from "../components/reportOptions";
import FTModal from "../../../components/common/FTModal";

type TModalReportOptionsProps = TReportOptionsProps & {
  onClose?: () => void;
  modalVariant?: 'showReportOptions' | 'showCustomReportOptions' | 'showModalNewCustomReportStep3';
  translationKeyPrefix?: 'reports.optionsForm' | 'reports.createCustomReport.reportOptions';
  filterValuesForPrefill?: any; // for prefilling the filter values
};

const ModalReportOptions: FC<TModalReportOptionsProps> = ({
  filterValuesForPrefill,
  reportType,
  reportId,
  subReportType,
  onClose,
  onSubmit,
  modalVariant = 'showReportOptions',
  customSubmitLabel,
  translationKeyPrefix = 'reports.optionsForm',
}) => {
  const { t } = useTranslation('translation', { keyPrefix: translationKeyPrefix });
  const modalsState = useSelector((state: { commonReducer: { modals: TModalsState } }) => state.commonReducer.modals);
  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, [modalVariant]: false }));
    if (onClose) onClose();
  };

  if (modalsState?.[modalVariant] === false) return null;

  return (
    <FTModal
      visible={modalsState?.[modalVariant]}
      heading={t("heading")}
      onHide={hideModal}
      dismissible={true}
      disableOverlay={true}
      renderAboveImpersonationBar={true}
      position="center"
    >

      <div className="grid grid-cols-6 gap-6">

        {/* sub heading moved inside ReportOptions via sgowSubHeading flag to make the text conditional based on available filters */}
        {/* <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
          {t("sub_heading")}
        </p> */}

        <ReportOptions
          reportFilters={filterValuesForPrefill ? filterValuesForPrefill : undefined}
          reportType={reportType}
          reportId={reportId}
          subReportType={subReportType}
          customSubmitLabel={customSubmitLabel}
          onSubmit={({ filterValues, reportType, category, reportId, navigate, reportFilters }) => {
            onSubmit?.({ filterValues, reportType, category, reportId, navigate, reportFilters });
            hideModal();
          }}
          onCancel={hideModal}
          showSubHeading={true} // added for conditional sub heading
        />

      </div>
    </FTModal>
  )
};
export default ModalReportOptions;